import { render, staticRenderFns } from "./BodyDeItem.vue?vue&type=template&id=065a9b76&scoped=true"
import script from "./BodyDeItem.vue?vue&type=script&setup=true&lang=js"
export * from "./BodyDeItem.vue?vue&type=script&setup=true&lang=js"
import style0 from "./BodyDeItem.vue?vue&type=style&index=0&id=065a9b76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065a9b76",
  null
  
)

export default component.exports